import { render } from "./AboutCards.vue?vue&type=template&id=4ad3dead&scoped=true"
import script from "./AboutCards.vue?vue&type=script&lang=js"
export * from "./AboutCards.vue?vue&type=script&lang=js"

import "./AboutCards.vue?vue&type=style&index=0&id=4ad3dead&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad3dead"]])

export default __exports__